import { Link } from '@cannect/new-components/atoms'
import { useBrand } from 'hooks/useBrand'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { getBrandHeaderLogo } from './brandLogo'
import { useHeader } from './useHeader'

import CartSheet from '@cannect/new-components/CartSheet'

export const HeaderDesktop = ({ isPublicFlow }: ReturnType<typeof useHeader>) => {
  const [isCartSheetOpen, setIsCartSheetOpen] = useState(false)
  const { config } = useBrand()
  const { pathname } = useLocation()
  const isSameRouteHome = pathname === config.routes.home

  return (
    <>
      <div
        className="container w-full space-y-[18px] py-10"
        style={{ backgroundColor: config.headerBackground ?? config.colors.primary }}>
        <div className="flex items-center justify-center gap-8">
          {!isPublicFlow && (
            <div className="flex flex-1 items-center justify-center gap-4">
              {/* Vikura/Remederi: home aponta para a própria página de agendamento —
                  navegação client-side não remonta o componente (mesma rota) e
                  deixa o formulário com estado antigo. isExternal força reload. */}
              <Link to={config.routes.home} isExternal={isSameRouteHome}>
                <img src={getBrandHeaderLogo(config.key)} alt={`Logo ${config.name}`} className="w-36 object-contain" />
              </Link>
            </div>
          )}
        </div>

        {!isPublicFlow && (
          <div className="flex w-full items-center justify-between gap-[40px]">
            <div className="flex w-full min-w-60 flex-1 flex-wrap items-center justify-between">
              <div className="flex items-center justify-center gap-2" />
            </div>
          </div>
        )}
      </div>

      <CartSheet isOpen={isCartSheetOpen} onClose={() => setIsCartSheetOpen(false)} />
    </>
  )
}
